<template>
  <div class="col-12 ps-3">
    <div class="row mb-3 align-items-center">
      <label class="col-2 col-form-label">Language</label>
      <div class="col-4">
        <select class="form-select" v-model="language_id">
          <option v-for="option in languages" :key="option.value" :value="option.value">
            {{ option.text }}
          </option>
        </select>
      </div>
    </div>
    
    <div class="row mb-3 align-items-center">
      <label class="col-2 col-form-label">OSC Mail subject</label>
      <div class="col-10">
        <input 
          class="form-control" 
          v-model="mailtext_subject" 
          @change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_subject',mailtext_subject)"
        />
      </div>
    </div>
    
    <div class="row mb-3 d-none">
      <label class="col-12 col-form-label">Introduction text</label>
      <div class="col-12">
        <vue-editor 
          v-model="mailtext_start" 
          :editorToolbar="editortoolbar"
          @text-change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_start',mailtext_start)"  
        ></vue-editor>
      </div>
    </div>
    
    <div class="row mb-3">
      <label class="col-12 col-form-label">Body text</label>
      <div class="col-12">
        <vue-editor 
          v-model="mailtext_text" 
          :editorToolbar="editortoolbar"
          @text-change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_text',mailtext_text)"
        ></vue-editor>
      </div>
    </div>
    
    <div class="row mb-3 d-none">
      <label class="col-12 col-form-label">End text</label>
      <div class="col-12">
        <vue-editor 
          v-model="mailtext_end" 
          :editorToolbar="editortoolbar"
          @text-change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_end',mailtext_end)"
        ></vue-editor>
      </div>
    </div>
    
    <div class="row mb-3 align-items-center">
      <label class="col-2 col-form-label">Copyright text</label>
      <div class="col-10">
        <input 
          class="form-control" 
          v-model="copyright_text" 
          @change="savefield('g_oscdefaultmailtexts',mailtext_id,'copyright_text',copyright_text)"
        />
      </div>
    </div>
    
    <div class="row mb-3 align-items-center">
      <label class="col-2 col-form-label">Text for 'Your Personal Link'</label>
      <div class="col-10">
        <input 
          class="form-control" 
          v-model="mailtext_your_personal_link" 
          @change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_your_personal_link',mailtext_your_personal_link)"
        />
      </div>
    </div>
    
    <div class="row mb-3 align-items-center">
      <label class="col-2 col-form-label">Text for 'Your Personal Code'</label>
      <div class="col-10">
        <input 
          class="form-control" 
          v-model="mailtext_your_personal_code" 
          @change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_your_personal_code',mailtext_your_personal_code)"
        />
      </div>
    </div>
    
    <div class="row mb-3 align-items-center">
      <label class="col-2 col-form-label">Text for 'Survey End Date'</label>
      <div class="col-10">
        <input 
          class="form-control" 
          v-model="mailtext_survey_end_date" 
          @change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_survey_end_date',mailtext_survey_end_date)"
        />
      </div>
    </div>
    
    <div class="row mb-3 align-items-center">
      <label class="col-2 col-form-label">Text for 'Survey Name'</label>
      <div class="col-10">
        <input 
          class="form-control" 
          v-model="mailtext_survey_name" 
          @change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_survey_name',mailtext_survey_name)"
        />
      </div>
    </div>
    
    <div class="row mb-3 align-items-center">
      <label class="col-2 col-form-label">Survey member reminder subject</label>
      <div class="col-10">
        <input 
          class="form-control" 
          v-model="mailtext_subject_member_reminder" 
          @change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_subject_member_reminder',mailtext_subject_member_reminder)"
        />
      </div>
    </div>
    
    <div class="row mb-3 align-items-center">
      <label class="col-2 col-form-label">Consultant reminder subject</label>
      <div class="col-10">
        <input 
          class="form-control" 
          v-model="mailtext_subject_consultant_reminder" 
          @change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_subject_consultant_reminder',mailtext_subject_consultant_reminder)"
        />
      </div>
    </div>
    
    <div class="row mb-3">
      <label class="col-12 col-form-label">Consultant reminder text</label>
      <div class="col-12">
        <vue-editor 
          v-model="mailtext_text_consultant_reminder" 
          :editorToolbar="editortoolbar" 
          @text-change="savefield('g_oscdefaultmailtexts',mailtext_id,'mailtext_text_consultant_reminder',mailtext_text_consultant_reminder)"
        ></vue-editor>
      </div>
    </div>
  </div>
</template>
<script>
import VueEditor from "./CustomControls/VueEditor.vue";

var editortools = [
  [{ font: [] }],
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ color: [] }, { background: [] }],
];

export default {
  components: {
    VueEditor,
  },
  name: 'DefaultOSCMailTexts',
  mounted() {
    this.languages_get();
  },
  data: function() {
    return {
      editortoolbar: editortools,
      mailtext_id: 0,
      mailtext_subject: '',
      mailtext_start: '',
      mailtext_text: '',
      mailtext_end: '',
      copyright_text: '',
      mailtext_your_personal_link: '',
      mailtext_your_personal_code: '',
      mailtext_survey_end_date: '',      
      mailtext_survey_name: '',      
      mailtext_subject_member_reminder: '',
      mailtext_subject_consultant_reminder: '',
      mailtext_text_consultant_reminder: '',
      language_id: null,
      languages: []
    }
  },
  computed: {
  },
  watch: {
    language_id: function() {
      if (this.language_id != null) {
        this.mailtext_get();
      }
    },
  },
  methods: {
    mailtext_get() {
      var filter = {
        mailtext_language_id: {
          operator: '=',
          value: this.language_id,
        }
      }
      this.$store.dispatch('defaultoscmailtext_fetch',{ filter: filter })
      .then((resp) => {
        if (resp.data.total > 0) {
          var mailtext = resp.data.result[0];
          this.mailtext_id = mailtext.id;
          this.mailtext_subject = mailtext.mailtext_subject;
          this.mailtext_start = mailtext.mailtext_start;
          this.mailtext_text = mailtext.mailtext_text;
          this.mailtext_end = mailtext.mailtext_end;
          this.copyright_text = mailtext.copyright_text;
          this.mailtext_your_personal_link = mailtext.mailtext_your_personal_link;
          this.mailtext_your_personal_code = mailtext.mailtext_your_personal_code;
          this.mailtext_survey_end_date = mailtext.mailtext_survey_end_date;          
          this.mailtext_survey_name = mailtext.mailtext_survey_name;          
          this.mailtext_subject_member_reminder = mailtext.mailtext_subject_member_reminder;
          this.mailtext_subject_consultant_reminder = mailtext.mailtext_subject_consultant_reminder;
          this.mailtext_text_consultant_reminder = mailtext.mailtext_text_consultant_reminder;
        } else {
          this.mailtext_id = 0;
          this.mailtext_subject = '';
          this.mailtext_start = '';
          this.mailtext_text = '';
          this.mailtext_end = '';
          this.copyright_text = '';
          this.mailtext_your_personal_link = '';
          this.mailtext_your_personal_code = '';
          this.mailtext_survey_end_date = '';          
          this.mailtext_survey_name = '';          
          this.mailtext_subject_member_reminder = '';
          this.mailtext_subject_consultant_reminder = '';
          this.mailtext_text_consultant_reminder = '';
        }
      });
    },
    languages_get() {
      var languages = [];
      languages.push({
        value: null,
        text: 'Please select',
      });
      this.$store.dispatch('languages_fetch')
      .then((resp) => {
        var dblang = resp.data.result;
        for (var i=0;i<dblang.length;i++) {
          languages.push({
            value: dblang[i].id,
            text: dblang[i].language_name,
          });
        }
        this.languages = languages;
      });
    },
    savefield(tablename,id,fieldname,value) {
      if (fieldname.indexOf('_date') != -1 && fieldname != 'mailtext_survey_end_date') {
        value = this.format_date(value);
      }
      if ( id > 0 ) { 
        var record = {
          id: id,
          [fieldname]: value,
        }
        this.$store.dispatch('field_save', { tablename: tablename,record: record })
      }
    }, 
  }
}
</script>
<style>
</style>
